import Layout from '@/layout'

const route = {
  path: '/adx/list',
  component: Layout,
  redirect: '/adx/list',
  alwaysShow: true, // will always show the root menu
  name: 'ADXList',
  meta: {
    title: 'ADX',
    icon: 'ADX',
    roles: [
      'adx'
    ]
  },
  children: [
    {
      path: '/adx/strategy/index',
      component: () => import('@/views/adx/strategy/index.vue'),
      name: 'ADXAccountList',
      meta: {
        title: '素材列表',
        // icon: 'component',
        roles: [
          'adx.material'
        ]
      }
    },
    {
      path: '/adx/Materials/index',
      component: () => import('@/views/adx/Materials/index.vue'),
      name: 'MaterialsList',
      meta: {
        title: '策略列表',
        // icon: 'component',
        roles: [
          'adx.strategy'
        ]
      }
    },
    {
      path: '/adx/adxaccount/index',
      component: () => import('@/views/adxAccount/index.vue'),
      name: 'Adxaccount',
      meta: {
        title: '账户列表',
        // icon: 'component',
        roles: [
          'adx.account'
        ]
      }
    },
    {
      path: '/adxbatch/index',
      component: () => import('@/views/adxBatch/index.vue'),
      name: 'Adxbatch',
      meta: {
        title: '批次列表',
        // icon: 'component',
        roles: [
          'adx.bulk'
        ]
      }
    },
    {
      path: '/adxkarka/index',
      component: () => import('@/views/adxkarka/index.vue'),
      name: 'Adxbatch',
      meta: {
        title: 'ADX_KAFKA批次列表',
        // icon: 'component',
        roles: [
          'adx.kafka.task'
        ]
      }
    },
    {
      path: '/adxcolorchange/index',
      component: () => import('@/views/adxcolorchange/index.vue'),
      name: 'Adxcolorchange',
      meta: {
        title: '变色龙订单ID',
        // icon: 'component',
        roles: [
          'adx.orderId'
        ]
      }
    },
    {
      path: '/adxrule/index',
      component: () => import('@/views/adxrule/index.vue'),
      name: 'Adxrule',
      meta: {
        title: '自动创建配置',
        // icon: 'component',
        roles: [
          'adx.create_ad_config'
        ]
      }
    },
    {
      path: '/adxtasklist/index',
      component: () => import('@/views/adxtasklist/index.vue'),
      name: 'Adxtasklist',
      meta: {
        title: '自动创建记录',
        // icon: 'component',
        roles: [
          'adx.create_ad_record'
        ]
      }
    },
    {
      path: '/adx/MaterialsInfo/index',
      component: () => import('@/views/adx/Materials/Info/index.vue'),
      name: 'MaterialInfo',
      meta: {
        title: '短剧素材',
        // icon: 'component',
        roles: [
          'adx.strategy'
        ]
      },
      hidden: true
    },
    {
      path: '/adxTaskDetails/index',
      component: () => import('@/views/adxTaskDetails/index.vue'),
      name: 'MaterialInfo',
      meta: {
        title: '任务详情',
        // icon: 'component',
        roles: [
          'adx.kafka.task'
        ]
      },
      hidden: true
    },
    {
      path: '/adx/MaterialsUpload/index',
      component: () => import('@/views/adx/Materials/upload/index.vue'),
      name: 'MaterialsUpload',
      meta: {
        title: '本地素材上传',
        // icon: 'component',
        roles: [
          'adx.strategy'
        ]
      }
    }
  ]
}

export default route
